import { envs } from '@ctct/infrastructure-layer';

/** Guru Lite offer partner (PN: guruconference2). */
export const GURU_LITE_OFFER_PARTNER_UID = 1142347134401;

// Optional chaining: some tests mock `envs` with a partial shape.
const l1TestPUIDs = envs.isL1?.() ? [1100718985911] : [];
const s1TestPUIDs = envs.isS1?.() ? [1100715775408] : [];

export const GURU_LITE_OFFER_PARTNER_UIDS = [GURU_LITE_OFFER_PARTNER_UID, ...l1TestPUIDs, ...s1TestPUIDs];
